var render = function render(){var _vm=this,_c=_vm._self._c;return _c('nav',{staticClass:"gm-tabs",attrs:{"aria-label":"Groove forms versions"}},[_c('router-link',{attrs:{"to":"/forms/new"}},[_vm._v("New Groove forms")]),_c('router-link',{attrs:{"to":"/forms"}},[_vm._v("Groove forms legacy")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }